<template>
    <div class="ticket-details-compact">
        <div class="d-flex align-items-center mb-2">
            <span class="material-icons text-primary me-2" style="font-size: 1.5rem;">confirmation_number</span>
            <span class="fw-bold text-primary">Ticket #{{ ticket.ticketId }}</span>
        </div>
        <div class="container-fluid">
            <div class="row g-2">
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">Company</label>
                    <input type="text" class="form-control form-control-sm" :value="ticket.companyName" disabled />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">Job Name</label>
                    <input type="text" class="form-control form-control-sm" :value="ticket.jobName" disabled />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">Serial (SN)</label>
                    <input type="text" class="form-control form-control-sm" :value="ticket.sn" disabled />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">User</label>
                    <input type="text" class="form-control form-control-sm" :value="ticket.user" disabled />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">User ID</label>
                    <input type="text" class="form-control form-control-sm" :value="ticket.user_id" disabled />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">Status</label>
                    <input type="text" class="form-control form-control-sm" :value="statusText(ticket.status)" disabled style="font-weight: 600;" />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">Sent Date</label>
                    <input type="text" class="form-control form-control-sm" :value="formatDate(ticket.sentDate)" disabled />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">Received Date</label>
                    <input type="text" class="form-control form-control-sm" :value="formatDate(ticket.receivedDate)" disabled />
                </div>
                <div class="col-12 col-sm-8">
                    <label class="form-label-compact">Notes</label>
                    <input type="text" class="form-control form-control-sm text-truncate" :value="ticket.sentNotes" disabled style="max-width:100%;white-space:pre-line;" />
                </div>
                <div class="col-6 col-sm-4">
                    <label class="form-label-compact">Last Update</label>
                    <input type="text" class="form-control form-control-sm" :value="formatDate(ticket.lastUpdate)" disabled />
                </div>
            </div>
            <hr>
            <div class="row gx-3 justify-content-center">
                <div class="col-md-4  mt-3">
                    <form @submit.prevent="submitUpdate" class="ticket-edit-form p-2 card p-3 mb-3">
                        <h5 class="mb-3">Edit Ticket</h5>
                        <div class="mb-3">
                            <label class="form-label-compact mb-1">Job Name</label>
                            <input
                                type="text"
                                v-model="editForm.jobName"
                                class="form-control form-control-sm"
                                :placeholder="ticket.jobName"
                                :disabled="ticket.jobId !== 0"
                                required
                            />
                            <div v-if="ticket.jobId !== 0" class="text-muted smallText">
                                You cannot modify the Job Name because it is linked to a station.
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label-compact mb-1">Status</label>
                            <div class="btn-group w-100 mb-2" role="group" aria-label="Status filter">
                                <button
                                    type="button"
                                    class="btn"
                                    :class="{'btn-primary': editForm.status === 1, 'btn-outline-dark': editForm.status !== 1}"
                                    @click="editForm.status = 1"
                                >
                                    🚀 Opened
                                </button>
                                <button
                                    type="button"
                                    class="btn"
                                    :class="{'btn-primary': editForm.status === 3, 'btn-outline-dark': editForm.status !== 3}"
                                    @click="editForm.status = 3"
                                >
                                    ✅ Closed
                                </button>
                            </div>
                        </div>
                        <div class="text-end">
                            <button type="submit" class="btn btn-success btn-sm" :disabled="isUpdating">Update Ticket</button>

                        </div>
                    </form>
                </div>
                <div class="col-md-7  mt-3 ms-2">
                    <form @submit.prevent="submitTicketDetail" class="card p-3 mb-3">
                        <h5 class="mb-3">Add Ticket Event</h5>
                        <div class="mb-3">
                            <label class="form-label-compact">Event Date</label>
                            <input type="datetime-local" v-model="ticketDetailForm.eventDate" class="form-control form-control-sm" required />
                        </div>
                        <div class="mb-3">
                            <label class="form-label-compact">Details</label>
                            <textarea v-model="ticketDetailForm.details" class="form-control form-control-sm" maxlength="180" rows="3" required></textarea>
                        </div>
                        <div class="mb-3">
                            <label class="form-label-compact">PO</label>
                            <input type="text" v-model="ticketDetailForm.po" class="form-control form-control-sm" maxlength="50" placeholder="--" />
                        </div>
                        <div class="text-end">
                            <button type="submit" class="btn btn-success btn-sm" :disabled="isAddingDetail">Add Detail</button>
                        </div>
                    </form>
                </div>

                <div class="col-md-12 mt-3">
                    <div class="card p-3">
                        <h5 class="mb-3">Ticket Details</h5>
                        <div v-if="ticketDetails.length === 0" class="text-muted">No details found for this ticket.</div>
                        <div v-else class="table-responsive">
                            <table class="table table-sm table-striped align-middle">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Details</th>
                                        <th>PO</th>
                                        <th>User</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="detail in ticketDetails" :key="detail.id">
                                        <td>{{ formatDate(detail.eventDate) }}</td>
                                        <td>{{ detail.details }}</td>
                                        <td>{{ detail.po }}</td>
                                        <td>{{ detail.user }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    var config = require("@/config/api.json");
    const API = config.api;
    export default {
        data() {
            return {
                editForm: {
                    jobName: this.selectedTicket?.jobName || '',
                    status: this.selectedTicket?.status || 1,
                },
                isUpdating: false,
                ticketDetailForm: {
                    eventDate: '',
                    details: '',
                    po: '',
                },
                isAddingDetail: false,
                user: null,
                ticketDetails: [],
            };
        },
        watch: {
            selectedTicket: {
                immediate: true,
                handler(newVal) {
                    if (newVal) {
                        this.editForm.jobName = newVal.jobName || '';
                        this.editForm.status = newVal.status || 1;
                    }
                }
            },
            
        },
        name: "TicketEditEvent",
        props: {
            selectedTicket: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            ticket() {
                return this.selectedTicket || {};
            },
        },
       async mounted() {

            if (this.selectedTicket && this.selectedTicket.ticketId) {
                await this.fetchTicketDetails();
            }
             try {
                const { auth } = await import("@/fb");
                const user = auth.currentUser;
                if (user) {
                    this.user = user;
                } else {
                    // Si no está disponible inmediatamente, esperar a onAuthStateChanged
                    const { onAuthStateChanged } = await import("firebase/auth");
                    await new Promise((resolve) => {
                        onAuthStateChanged(auth, (u) => {
                            if (u) {
                                this.user = u;
                                resolve();
                            }
                        });
                    });
                }
            } catch (e) {
                this.user = null;
            }
        },
        methods: {
             async fetchTicketDetails() {
             this.ticketDetails = [];
                if (!this.ticket || !this.ticket.ticketId) {
                    this.ticketDetails = [];
                    return;
                }
                try {
                    const res = await axios.get(`${API}/get-ticket-details`, { params: { ticketId: this.ticket.ticketId } });
                    this.ticketDetails = Array.isArray(res.data) ? res.data : [];
                } catch (e) {
                    this.ticketDetails = [];
                }
            },
            formatDate(date) {
                if (!date) return "";
                const d = new Date(date);
                return d.toLocaleString();
            },
            statusText(status) {
                switch (status) {
                    case 1: return "🚀 Opened";
                    case 2: return "🧰 In Repair";
                    case 3: return "✅ Closed";
                    default: return "Unknown";
                }
            },
            async submitTicketDetail() {
                // Validaciones
                if (!this.ticket || !this.ticket.ticketId) {
                    this.notify('error', 'TicketId is required');
                    return;
                }
                if (!this.ticketDetailForm.eventDate) {
                    this.notify('error', 'Event Date is required');
                    return;
                }
                if (!this.ticketDetailForm.details || !this.ticketDetailForm.details.trim()) {
                    this.notify('error', 'Details are required');
                    return;
                }
                let poValue = this.ticketDetailForm.po && this.ticketDetailForm.po.trim() ? this.ticketDetailForm.po.trim() : '--';
                this.isAddingDetail = true;
                try {
                    // Obtener usuario logueado igual que en Inventory.vue
                    let userEmail = '';
                    if (this.user && this.user.email) {
                        userEmail = this.user.email;
                    } else if (this.$root && this.$root.user && this.$root.user.email) {
                        userEmail = this.$root.user.email;
                    } else if (this.ticket.user) {
                        userEmail = this.ticket.user;
                    }
                    if (!userEmail) {
                        this.notify('error', 'User not found');
                        return;
                    }
                    const payload = {
                        ticketId: this.ticket.ticketId,
                        eventDate: this.ticketDetailForm.eventDate,
                        details: this.ticketDetailForm.details.trim(),
                        po: poValue,
                        user: userEmail
                    };
                    const res = await axios.post(`${API}/add-ticket-detail`, payload);
                    if (res.data && res.data.message) {
                        this.notify('success', 'Ticket detail added successfully');
                        // Limpiar formulario
                        this.callLog(this.user.email, 'create', 'ticket-details', `Created ticket-details PO: ${poValue}`);
                        this.ticketDetailForm.eventDate = '';
                        this.ticketDetailForm.details = '';
                        this.ticketDetailForm.po = '';
                        this.fetchTicketDetails();
                    } else {
                        this.notify('error', res.data && res.data.error ? res.data.error : 'Error adding ticket detail');
                    }
                } catch (e) {
                    this.notify('error', 'Error adding ticket detail');
                } finally {
                    this.isAddingDetail = false;
                }
            },
            async submitUpdate() {
                this.isUpdating = true;

                try {
                    const payload = {
                        ticketId: this.ticket.ticketId,
                        jobName: this.editForm.jobName,
                        status: this.editForm.status
                    };
                    const res = await axios.post(`${API}/updateTicket`, payload);
                    if (res.data && res.data.success) {
                        this.$emit('ticketUpdated', payload);
                        this.notify('success', 'Ticket updated successfully');
                        this.callLog(this.user.email, 'update', 'tickets', `Updated ticket with ID ${this.selectedTicket.ticketId}`);
                        this.selectedTicket.jobName = this.editForm.jobName;
                        this.selectedTicket.status = this.editForm.status;
                    } else {
                        this.notify('error', res.data && res.data.error ? res.data.error : 'Error updating ticket');
                    }
                } catch (e) {
                    this.notify('error', 'Error updating ticket');
                } finally {
                    this.isUpdating = false;
                }
            },
        }
    };
</script>

<style scoped>
    .ticket-edit-form {
        border-radius: 8px;
        box-shadow: 0 1px 4px rgba(80, 60, 120, 0.06);
        margin-top: 0.5rem;
    }

    .ticket-details-compact {
        font-size: 0.97rem;
        padding: 0.5rem 0.2rem 0.2rem 0.2rem;
    }

    .form-label-compact {
        font-weight: 600;
        margin-bottom: 0.1rem;
        font-size: 0.93em;
    }

    .form-value-compact {
        border-radius: 4px;
        padding: 0.25rem 0.5rem;
        min-height: 28px;
        font-weight: 500;
        word-break: break-word;
    }

    .badge {
        font-size: 0.95rem;
        padding: 0.3em 0.7em;
    }

    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
</style>